import { render, staticRenderFns } from "./order_statistics.vue?vue&type=template&id=d516e2ec&scoped=true"
import script from "./order_statistics.vue?vue&type=script&lang=ts"
export * from "./order_statistics.vue?vue&type=script&lang=ts"
import style0 from "./order_statistics.vue?vue&type=style&index=0&id=d516e2ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d516e2ec",
  null
  
)

export default component.exports